export default __webpack_public_path__ + "static/media/whistle_button.e864af14.svg";